<template>
  <PersonalAreaTemplate>
    <v-form v-if="!editing" class="d-grid gap-row-5" ref="form" lazy-validation>
      <BaseInput
        :label="translation['salary_hourly']"
        v-model="data.salary"
        placeholder="–"
        readonly
        :measure="translation['euro_hour']"
        view
        :view-value="data.salary ? $formatCurrency(data.salary) + ' ' + translation['euro_hour'] : '—'"
      />
      <BaseInput
        :label="translation['personal_premium']"
        v-model="data.premium"
        placeholder="–"
        readonly
        :measure="translation['euro_hour']"
        view
        :view-value="data.premium ? $formatCurrency(data.premium) + ' ' + translation['euro_hour'] : '—'"
      />
    </v-form>
    <div v-else class="d-grid gap-5">
      <BaseCard :title="translation['current_data']">
        <v-form class="d-grid grid-col-lg-1-1 gap-5" lazy-validation>
          <div class="d-flex flex-column gap5">
            <SalaryTable
              :items="[salaryData.salary]"
              :edit="$userCheckAccess({ abilities: 'edit_employee_salary' })"
            />
            <div class="d-flex gap5">
              <BaseButton
                v-if="$userCheckAccess({ abilities: 'edit_employee_salary' })"
                :text="localStorage.translations.pages.common.buttons['sohranit']"
                default_icon="button-save"
                @click="setNewSalary"
              />
            </div>
          </div>
          <div class="d-flex flex-column gap5">
            <PremiumTable
              :items="[salaryData.premium]"
              :edit="$userCheckAccess({ abilities: 'edit_employee_salary' })"
            />
            <div class="d-flex gap5">
              <BaseButton
                v-if="$userCheckAccess({ abilities: 'edit_employee_salary' })"
                :text="localStorage.translations.pages.common.buttons['sohranit']"
                default_icon="button-save"
                @click="setNewPremium"
              />
            </div>
          </div>
        </v-form>
      </BaseCard>
      <BaseCard :title="translation['historical_data']">
        <div class="d-grid grid-col-lg-1-1 gap-5">
          <SalaryTable :items="salaryData?.salary?.history" />
          <PremiumTable :items="salaryData?.premium?.history" />
        </div>
      </BaseCard>
    </div>
  </PersonalAreaTemplate>
</template>

<script>
import PersonalAreaTemplate from './personalAreaTemplate.vue'
import SalaryTable from '../personalArea/salary/SalaryTable.vue'
import PremiumTable from '../personalArea/salary/PremiumTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Salary',
  components: { PersonalAreaTemplate, PremiumTable, SalaryTable },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          salary: '—',
          premium: '—',
        }
      },
    },
    editing: Boolean,
    onSave: Function,
  },
  data: () => ({
    edit: Boolean,
    salaryData: [],
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    ...mapGetters('commonUser', ['commonUserData']),
    ...mapGetters('user', ['userData']),
    ...mapGetters('employeeSalaryInfo', ['employeeSalaryInfo']),
    translation() {
      return this.localStorage.translations.pages['setting-personal_area'].labels
    },
  },
  created() {
    if (this.editing) {
      this.getStarted()
    }
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    salaryData: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('commonUser', ['onCommonUserData']),
    ...mapActions('employeeSalaryInfo', [
      'onEmployeeSalaryInfo',
      'onUpdateEmployeeSalary',
      'onUpdateEmployeePremium',
    ]),
    ...mapMutations(['setLoadingAnimation']),
    async getStarted() {
      let employeeId = this?.$route?.params?.userId || this?.userData?.employee?.user_id
      if (employeeId)
        await this.onCommonUserData(employeeId).then(() => {
          this.getSalaryInfo()
        })
    },
    async getSalaryInfo() {
      this.setLoadingAnimation(true)
      if (this?.commonUserData?.employee)
        await this.onEmployeeSalaryInfo({ employeeId: this.commonUserData.employee.id }).then(
          (res) => {
            this.salaryData = res.data
            this.onCheckChange({ overwrite: true })
            this.setLoadingAnimation(false)
          },
        )
    },
    async setNewSalary() {
      let data = {
        employee_id: this.commonUserData.employee.id,
        value: Number(this?.salaryData?.salary?.value || 0),
      }
      await this.onUpdateEmployeeSalary(data)
        .then((res) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.getSalaryInfo()
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] +
                ' ' +
                err.response.data.message,
              IsError: true,
            },
            { root: true },
          )
        })
    },
    async setNewPremium() {
      let data = {
        employee_id: this.commonUserData.employee.id,
        value: Number(this?.salaryData?.premium?.value || 0),
        notes: this?.salaryData?.premium?.notes || '',
      }
      await this.onUpdateEmployeePremium(data)
        .then((res) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.getSalaryInfo()
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] +
                ' ' +
                err.response.data.message,
              IsError: true,
            },
            { root: true },
          )
        })
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { employeeSalary: this.salaryData },
        overwrite,
      })
    },
    saveChange() {
      this.setNewSalary()
      this.setNewPremium()
      this.onNavigationGuardianCheck({
        data: { employeeSalary: this.salaryData },
        overwrite: true,
      })
    },
  },
}
</script>

<style scoped></style>